import React, { useState, useEffect } from 'react';
import { Grid, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import FieldValue from '../FieldValue';

const useStyles: any = makeStyles(() => ({
  showMore: {
    fontWeight: 500,
    cursor: 'pointer',
  },
}));

interface Props {
  items: string[];
}

const CheckoutItemList = (props: Props) => {
  const { items } = props;
  const classes = useStyles();
  const [openShowMoreLink, setOpenShowMoreLink] = useState(false);
  const [visibleItems, setVisibleItems] = useState<Array<string>>([]);

  useEffect(() => {
    if (items) {
      handleDisplayDescriptions();
    }
  }, [items]);

  const handleDisplayDescriptions = () => {
    setOpenShowMoreLink(!openShowMoreLink);
    if (openShowMoreLink || items.length <= 3) {
      setVisibleItems(items);
    } else {
      setVisibleItems(items.slice(0, 3));
    }
  };

  return (
    <Grid container>
      {visibleItems.map((item: any, key: any) => {
        return (
          <FieldValue key={key} dataTestId={item}>
            {item}
          </FieldValue>
        );
      })}
      {items.length > 3 && (
        <Typography variant='body1'>
          <Link onClick={handleDisplayDescriptions} data-testid='uia-showMore' className={classes.showMore} underline='none'>
            {openShowMoreLink ? 'Show more' : 'Show less'}
          </Link>
        </Typography>
      )}
    </Grid>
  );
};

export default CheckoutItemList;
